export function includesAny(str: string, substrings: string[]): boolean {
    return substrings.some(substring => str.includes(substring))
}

export function includesAll(str: string, substrings: string[]): boolean {
    return substrings.every(substring => str.includes(substring))
}